import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { licenseSlice } from '@/store/licenseSlice'
import { LicenseStrings } from '@/store/licenseSlice/utils/licenseStrings.ts'

export const bookingPolicyStringSelector = createSelector(
  [licenseSlice.selectors.strings],
  (strings) => {
    if (
      !rd.isSuccess(strings) ||
      (rd.isSuccess(strings) && strings.value.length === 0)
    ) {
      return null
    }

    return (
      strings.value.find(
        (translatedString) =>
          translatedString.namespace === LicenseStrings.Namespace &&
          translatedString.key === LicenseStrings.BookingPolicyTextKey
      )?.value ?? null
    )
  }
)
